import Parse from "parse";

export interface DatasetExportAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  dataset_zip?: Parse.File | undefined;
  file?: Parse.File | undefined;
  hash?: string | undefined;
}

export class DatasetExport extends Parse.Object<DatasetExportAttributes> {
  static className: string = "Antiscam_DatasetExport";

  constructor(data?: Partial<DatasetExportAttributes>) {
    super("Antiscam_DatasetExport", data as DatasetExportAttributes);
  }

  get dataset_zip(): Parse.File | undefined {
    return super.get("dataset_zip");
  }
  set dataset_zip(value: Parse.File | undefined) {
    super.set("dataset_zip", value);
  }

  get file(): Parse.File | undefined {
    return super.get("file");
  }
  set file(value: Parse.File | undefined) {
    super.set("file", value);
  }

  get hash(): string | undefined {
    return super.get("hash");
  }
  set hash(value: string | undefined) {
    super.set("hash", value);
  }
}

Parse.Object.registerSubclass("Antiscam_DatasetExport", DatasetExport);
